import React from "react";
import { BrandContext } from '../context/brandContext';

const useBrandConfig = () => {
  const brandConfig = React.useContext(BrandContext);
  return brandConfig;
};

export default useBrandConfig;